/* eslint-disable import/prefer-default-export */
import { APP_REDUX_ROOT_KEY } from './constants';

export const selectAppState = state => state[APP_REDUX_ROOT_KEY];
